import { render, staticRenderFns } from "./newssearch.vue?vue&type=template&id=4086be8b&"
import script from "./newssearch.vue?vue&type=script&lang=js&"
export * from "./newssearch.vue?vue&type=script&lang=js&"
import style0 from "./newssearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports